import {
  dropdown,
  multi,
  OTHER,
  option,
  single,
  text,
  type UsFieldDef,
} from "../us-fields";

export const lungSliding = (side: "right" | "left", label: string) =>
  single(
    `thoracic.${side}.pleural_line`,
    label,
    [
      option("sliding_present", "Lung sliding present"),
      option("sliding_absent", "Lung sliding absent"),
      option("indeterminate", "Indeterminate"),
    ],
    { normal: "sliding_present" },
  );

export const PLEURAL_LINE = single(
  "thoracic.pleural_line",
  "Pleural line",
  [
    option("sliding_present", "Lung sliding present"),
    option("sliding_absent", "Lung sliding absent"),
  ],
  { normal: "sliding_present" },
);

const lungZone = (id: string, label: string) =>
  single(
    `thoracic.${id}`,
    label,
    [
      option("a_profile", "A-profile"),
      option("b_profile", "B-profile"),
      option("consolidation", "Consolidation"),
      OTHER,
      option("not_visualized", "Not visualized"),
    ],
    { normal: "a_profile" },
  );

export const ANTERIOR_SUPERIOR_LUNG = lungZone(
  "anterior_superior",
  "Anterior-Superior lung",
);

export const ANTERIOR_INFERIOR_LUNG = lungZone(
  "anterior_inferior",
  "Anterior-Inferior lung",
);

export const LATERAL_SUPERIOR_LUNG = lungZone(
  "lateral_superior",
  "Lateral-Superior lung",
);

export const LATERAL_INFERIOR_LUNG = lungZone(
  "lateral_inferior",
  "Lateral-Inferior lung",
);

export const PLEURAL_SPACE = single(
  "thoracic.pleural_space",
  "Pleural space",
  [
    option("no_effusion", "No pleural effusion"),
    option("effusion", "Pleural effusion", {
      reveals: [
        single(
          "thoracic.effusion_size",
          "Size",
          [
            option("small", "Small"),
            option("moderate", "Moderate"),
            option("large", "Large"),
          ],
          { heading: "Pleural effusion size and classification" },
        ),
        single("thoracic.effusion_classification", "Classification", [
          option("simple", "Simple"),
          option("complex", "Complex"),
          OTHER,
        ]),
      ],
    }),
    option("consolidation", "Consolidation"),
    option("not_visualized", "Not visualized"),
  ],
  { normal: "no_effusion" },
);

export const LUNG_FINDINGS: readonly UsFieldDef[] = [
  PLEURAL_LINE,
  ANTERIOR_SUPERIOR_LUNG,
  ANTERIOR_INFERIOR_LUNG,
  LATERAL_SUPERIOR_LUNG,
  LATERAL_INFERIOR_LUNG,
  PLEURAL_SPACE,
  text("thoracic.other_findings", "Other lung findings"),
];

export const PNEUMONIA_LOCATION = dropdown(
  "thoracic.pneumonia_location",
  "Pneumonia location(s)",
  [
    option("not_applicable", "N/A"),
    option("right_anterior_superior", "Right anterior-superior"),
    option("right_anterior_inferior", "Right anterior-inferior"),
    option("right_lateral_superior", "Right lateral-superior"),
    option("right_lateral_inferior", "Right lateral-inferior"),
    option("left_anterior_superior", "Left anterior-superior"),
    option("left_anterior_inferior", "Left anterior-inferior"),
    option("left_lateral_superior", "Left lateral-superior"),
    option("left_lateral_inferior", "Left lateral-inferior"),
  ],
);

export const THORACIC_IMPRESSION = multi("thoracic.impression", "Impression", [
  option("normal_thoracic", "Normal thoracic ultrasound"),
  option("pulmonary_edema", "Pulmonary edema"),
  option("pneumothorax", "Pneumothorax", { sided: true }),
  option("pleural_effusion", "pleural effusion", { sided: true }),
  option("pneumonia", "Pneumonia, location(s)", {
    reveals: [PNEUMONIA_LOCATION],
  }),
  option("indeterminate", "Indeterminate"),
  OTHER,
]);

export const ANTERIOR_LUNG = lungZone("anterior", "Anterior lung");
